export const blockIconsNotificationVpnLock = (
	<span className='material-symbols-outlined'>vpn_lock</span>
);
